import awaitWrap from '../../../../procedures/await-wrap';
import httpWrap from '../../../../procedures/http-wrap';
import action from '../../../abstract/action';


const handle = async (
  {
    $vs,
    item,
    reloadList,
    model: {
      api: {
        execute,
      },
    },
  },
) => {

  $vs.dialog({
    accept: async () => await httpWrap({
      $vs,
      action: execute,
      success: { text: 'Zadanie przekazane do wykonania' },
      onSuccess: reloadList,
    })(item),
    type: 'confirm',
    color: 'warning',
    title: 'Wykonaj zadanie',
    text: await awaitWrap(({ id }) => `Czy na pewno chcesz wykonać natychmiast zaplanowane zadanie systemowe o identyfikatorze ${ id }?`)(item),
    acceptText: 'Potwierdzam',
    cancelText: 'Wróć',
  });
};

export default action({
  label: 'Wykonaj',
  icon: 'PlayIcon',
  main: () => false,
  handle,
});
